export default "__VITE_ASSET__BrUlILJp__"